type EnvRecord = Record<string, unknown>;

// Vite exposes env values via `import.meta.env` in the browser. Jest (CJS) cannot even
// parse `import.meta`, so this module MUST NOT reference it.
// Instead, we read from a global set by `setViteEnv()` (called in `main.tsx`) and/or
// fall back to `process.env` for unit tests / Node.
export function getEnv(key: string): string {
  const fromGlobal = (globalThis as unknown as { __VITE_ENV__?: EnvRecord })
    .__VITE_ENV__?.[key];
  if (typeof fromGlobal === "string") return fromGlobal;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const fromProcess = (typeof process !== "undefined" ? (process as any).env?.[key] : undefined) as unknown;
  if (typeof fromProcess === "string") return fromProcess;

  return "";
}

export function setViteEnv(env: EnvRecord): void {
  (globalThis as unknown as { __VITE_ENV__?: EnvRecord }).__VITE_ENV__ = env;
}

